module.exports = __webpack_public_path__ + "img/lr-cb4-2-y1.ab8889dd.gif";